class AgoraVolumeManager {
    constructor () {
        this.volumes = new Map()
        this.callbacks = new Map()
        this.client = null
        this.isInitialized = false
    }

    // Call this once in your main App or Meeting component after rtcClient is created
    init ( client ) {

        if ( this.isInitialized && this.client ) return

        this.client = client
        this.isInitialized = true

        // 1. Tell Agora to start calculating volumes
        // interval: 200ms is standard for UI; 100ms is very smooth.
        this.client.enableAudioVolumeIndicator()

        // 2. Set up the global listener
        this.client.on( "volume-indicator", ( result ) => {
            result.forEach( ( item ) => {
                // Agora returns uid: 0 for the local user
                const uid = item.uid
                const level = item.level

                this.volumes.set( uid, level )

                if ( this.callbacks.has( uid ) ) {
                    this.callbacks.get( uid ).forEach( cb => cb( level ) )
                }
            } )
        } )
    }

    subscribe ( uid, callback ) {
        if ( !this.callbacks.has( uid ) ) {
            this.callbacks.set( uid, new Set() )
        }
        this.callbacks.get( uid ).add( callback )

        // Return the current volume immediately so UI isn't "dead" at start
        callback( this.volumes.get( uid ) || 0 )

        return () => {
            const listeners = this.callbacks.get( uid )
            if ( listeners ) {
                listeners.delete( callback )
                if ( listeners.size === 0 ) this.callbacks.delete( uid )
            }
        }
    }
}

export const agoraVolumeManager = new AgoraVolumeManager()